import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from 'axios';
import { dataUser } from "../Helpers/util";
import moment from 'moment';
import { TickList } from "../../Redux/action/tickList";
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';


import { toast } from 'react-toastify';
import axiosInstance from "../../utils/axiosInstance";
import $ from "jquery";
import SwSelect from "../Common/SwReactSelect/SwReactSelect";
import SwOffCanvas from "../Common/SwOffCanvas/SwOffCanvas";
import SwButton from "../Common/SwButtons/SwButtons";
import AntDDatePicker from "../Common/AntDDateTimePicker/AntDDatePicker";
import dayjs from "dayjs"
const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);

const TicketFilterExport = ({ show, onClose }) => {
  // const [raisedBy, setRaisedBy] = useState(false);
  const [locationSpoc, setLocationSpoc] = useState([]);
  const [location1, setLocation1] = useState(null);
  const [status, setStatus] = useState('');
  const [raisedStatus, setRaisedStatus] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false); // Changed from null to false
  const [locationError, setLocationError] = useState('')
  const [startError, setStartError] = useState('')
  const [endError, setEndError] = useState('')
  const headers = [
    { label: 'REQUEST NO', key: 'requestId' },
    { label: 'SUBCATEGORY', key: 'subCategory' },
    { label: 'SUBJECT', key: 'Subject' },
    { label: 'DESCRIPTION', key: 'Description' },
    { label: 'LOCATION', key: 'floorName' },
    { label: 'ASSIGNEE', key: 'ticketOwnerName' },
    { label: 'TICKET CREATED', key: 'createdTime' },
    { label: 'TICKET CLOSED', key: 'ticketCloseTime' },
    { label: 'RAISED BY', key: 'contactName' },
    { label: 'TICKET STATUS', key: 'Status' },
    { label: 'RESOLUTION', key: 'resolution' },
  ];

  useEffect(() => {

    const fetchLocations = async () => {
      try {
        let authToken = JSON.parse(localStorage.getItem('headData'));
        const axiosConfig = {
          params: { spoc: UserObj.rec_id, client: UserObj.company_id },
          headers: { Authorization: `${authToken?.spintlyToken}` }
        };
        const response = await axios.get(`${process.env.REACT_APP_API_URL}basic-data/get-centers-by-spoc`, axiosConfig);
        if (response.data.status === "success") {
          setLocationSpoc(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchLocations();
  }, []);

  const handleLocationChange = (selectedOption) => {
    setLocation1(selectedOption);
    // if (selectedOption.value === 'GGN6') {
    //   setRaisedBy(true);
    // }

    if (!selectedOption) {
      setLocationError("Location can't be empty");
    } else {
      setLocationError('');
    }
  };


  const handleStartDate = (e) => {
    setStartDate(e.target.value)
    if (e.target.value) {
      setStartError('');
    }
  }

  const handleEndDate = (e) => {
    setEndDate(e.target.value)
    if (e.target.value) {
      setEndError('');
    }
  }
  const StatusMethod = (param) => {
    setStatus(param.value);
  };

  const StatusMethod1 = (param) => {
    setRaisedStatus(param.value);
  };

  const ticketStatus = [
    { value: "All", label: "All" },
    { value: "Closed", label: "Closed" },
    { value: "In Progress", label: "In Progress" },
    { value: "Open", label: "Open" },
    // { value: "On Hold", label: "On Hold" }
  ];

  const ticketRaisedBy = [
    {
      value: "all",
      label: "All",
    },
    {
      value: "spoc",
      label: "SPOCs",
    },
    {
      value: "me",
      label: "Me",
    },
    {
      value: "nospoc",
      label: "Employees",
    },
  ];

  const handleExport = async (e) => {
    e.preventDefault();
    setLocationError('');
    setStartError('');
    setEndError('');
    let isValid = true;

    if (!location1) {
      setLocationError("Location can't be empty");
      isValid = false;
    }
    if (!startDate) {
      setStartError("Please choose start date");
      isValid = false;
    }
    if (!endDate) {
      setEndError("Please choose end date");
      isValid = false;
    }

    if (isValid) {
      try {
        const authToken = JSON.parse(localStorage.getItem('headData'));
        const location = location1 ? location1.value : (locationSpoc?.[0]?.centercode || '');
        const raisedByValue = raisedStatus;
        let raisedByValue1 = status === 'All' ? '' : status;
        let newCompanyId = JSON.parse(localStorage.getItem('headData'));
        const requestData = {
          company_id: newCompanyId?.organizationId,
          status: raisedByValue1,
          location: [location],
          startDate: startDate,
          endDate: endDate,
          raisedBy: raisedByValue
        };

        if (raisedStatus === 'me') {
          requestData.userId = String(UserObj.rec_id);
        }

        const axiosConfig = {
          headers: {
            'Authorization': `${authToken?.spintlyToken}`,
            'Content-Type': 'application/json'
          }
        };

        const response = await axios.post(`${process.env.REACT_APP_API_URL}tickets/downloadTickets`, requestData, axiosConfig);

        if (response.status === 200) {
          const responseData = response?.data?.data;
          const headers = [
            { label: 'REQUEST NO', key: 'requestId' },
            { label: 'SUBCATEGORY', key: 'subCategory' },
            { label: 'SUBJECT', key: 'Subject' },
            { label: 'DESCRIPTION', key: 'Description' },
            { label: 'LOCATION', key: 'floorName' },
            { label: 'ASSIGNEE', key: 'ticketOwnerName' },
            { label: 'TICKET CREATED', key: 'createdTime' },
            { label: 'TICKET CLOSED', key: 'ticketCloseTime' },
            { label: 'RAISED BY', key: 'contactName' },
            { label: 'TICKET STATUS', key: 'Status' },
            { label: 'RESOLUTION', key: 'resolution' },
          ];

          const dataForExcel = responseData.map(item => {
            return headers.map(header => item[header.key] || '');
          });

          // Add the header row to the data
          dataForExcel.unshift(headers.map(header => header.label));

          // Create a new workbook
          const wb = XLSX.utils.book_new();
          const ws = XLSX.utils.aoa_to_sheet(dataForExcel);

          // Add the worksheet to the workbook
          XLSX.utils.book_append_sheet(wb, ws, 'Tickets Data');

          // Write the Excel file to binary string
          const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

          // Create a Blob from the Excel data
          const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

          // Create a link element to trigger the download
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', 'tickets.xlsx');

          // Append the link to the document body and trigger the download
          document.body.appendChild(link);
          link.click();

          // Clean up resources
          document.body.removeChild(link);

          setTimeout(() => {
            toast.success('Ticket filtered data export successfully', {

            });
          }, 1000)

          onClose();

          setLocation1('');
          setEndDate('');
          setStartDate('');
          setStatus('');
          setRaisedStatus('');
        }

        setLoadingExport(false); // Reset loading state
      } catch (error) {
        console.error('Error exporting data:', error);
        setLoadingExport(false); // Reset loading state in case of error
      }
    }
  };

  const resetValue = () => {
    setLocation1(null);
    setStatus('');
    setRaisedStatus('');
    setStartDate(null);
    setEndDate(null);
  };


  return (
    <>
      <TickList />
      <SwOffCanvas
        show={show}
        onHide={onClose}
        title="Export Tickets"
        width="520px"
        id="myModalTicketExport"
        footer={
          <>
            <div className="OffCanvasFooter_Btns">
              <SwButton size="md" type="button" variant="dark-outline" onClick={resetValue}>
                Reset
              </SwButton>
              <SwButton size="md" onClick={handleExport}>
                Export
              </SwButton>
            </div>
          </>
        }
      >
        <form>
          <div className="card-body">
            <div>
              <div className="row">
                <div className="col-md-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Location Name<span className="Required">*</span></label>
                    <SwSelect
                      value={location1}
                      onChange={handleLocationChange}
                      options={locationSpoc.map(item => ({
                        value: item.centercode,
                        label: item.location_name
                      }))}
                      placeholder="Select Location"
                      isClearable={false}
                    />
                    <span className="SwTextDanger SwTextSmall">
                      {locationError}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Start Date<span className="Required">*</span></label>
                    <AntDDatePicker
                      format="YYYY-MM-DD"
                      value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
                      onChange={(date, dateString) =>
                        handleStartDate({ target: { value: dateString } })
                      }
                    />
                    <span className="SwTextDanger SwTextSmall">
                      {startError}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">End Date<span className="Required">*</span></label>
                    <AntDDatePicker
                      format="YYYY-MM-DD"
                      value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
                      onChange={(date, dateString) =>
                        handleEndDate({ target: { value: dateString } })
                      }
                    />
                    <span className="SwTextDanger SwTextSmall">
                      {endError}
                    </span>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Status</label>
                    <SwSelect
                      name="status"
                      options={ticketStatus}
                      onChange={StatusMethod}
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>


              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Raised by</label>
                    <SwSelect
                      name="status"
                      options={ticketRaisedBy}
                      onChange={StatusMethod1}
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </SwOffCanvas>
    </>
  );
};

export default TicketFilterExport;
